import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { MasterPlayerStatus } from './masterAudio';
import { masterPlayerMessages } from './masterPlayerMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the master player; each part uses its own slice of it */
import styles from './MasterPlayer.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MasterPlayButtonProps {
  status: MasterPlayerStatus;
  /** True while the AAC copy is not ready: the button is grey and does nothing. */
  disabled?: boolean;
  small?: boolean;
  onToggle: () => void;
}

/** The round play and pause button of the master player (design release-kit o1, o2). */
const MasterPlayButtonComponent: React.FC<MasterPlayButtonProps> = ({
  status,
  disabled = false,
  small = false,
  onToggle,
}) => {
  const intl = useIntl();
  const isActive = status === 'playing' || status === 'loading';
  let icon = faPlay;
  if (status === 'loading') {
    icon = faSpinnerThird;
  } else if (status === 'playing') {
    icon = faPause;
  }
  return (
    <button
      type="button"
      className={clsx(styles.playButton, small && styles.playButtonSmall)}
      onClick={onToggle}
      disabled={disabled}
      aria-label={intl.formatMessage(isActive ? masterPlayerMessages.pause : masterPlayerMessages.play)}
      aria-pressed={isActive}
    >
      <FontAwesomeIcon icon={icon} spin={status === 'loading'} />
    </button>
  );
};

export const MasterPlayButton = TypedMemo(MasterPlayButtonComponent);
